import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import ru from './locales/ru.json'
import pt from './locales/pt.json'
import es from './locales/es.json'
// he.json kept for future use — not loaded until Hebrew UI is enabled

const SUPPORTED = ['en', 'ru', 'pt', 'es']

function detectLanguage(): string {
  const saved = localStorage.getItem('i18nextLng')
  if (saved && SUPPORTED.includes(saved)) return saved
  const browser = navigator.language.slice(0, 2).toLowerCase()
  if (SUPPORTED.includes(browser)) return browser
  return 'en'
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ru: { translation: ru },
    pt: { translation: pt },
    es: { translation: es },
  },
  lng: detectLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export { i18n }
